import React, { InputHTMLAttributes } from 'react';
import Datepicker from '@mos-cat/datepicker';

import { THEME } from '@mos-cat/tooltip';
import Tooltip from '../Tooltip/Tooltip';
import { ERROR_DATE } from '../../../constants/errors';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string | boolean;
  disabled?: boolean;
  autoCapitalize?: any;
}

interface Props extends InputProps {
  key?: any;
  className?: string;
  placeholder: string;
  errorLocation?: 'placeholder' | 'tooltip' | 'textBelow';
  minDate: string;
  maxDate: string;
}

const DateField = ({
  error,
  disabled,
  className,
  placeholder,
  ...restProps
}: Props): JSX.Element => {
  const showErrorAtPlaceholder =
    typeof error === 'string' &&
    [ERROR_DATE.IS_IN_FUTURE, ERROR_DATE.IS_IN_PAST].includes(error);
  const showTooltip =
    typeof error === 'string' &&
    ![ERROR_DATE.IS_IN_FUTURE, ERROR_DATE.IS_IN_PAST].includes(error);

  return (
    <Tooltip
      theme={THEME.DANGER}
      content={error}
      isOpen={showTooltip}
      className={className}
    >
      <Datepicker
        error={!disabled && Boolean(error)}
        disabled={disabled}
        {...restProps}
        label={showErrorAtPlaceholder ? error : placeholder}
        className="ym-hide-content"
        errorLocation={'placeholder'}
        autoComplete="off"
      />
    </Tooltip>
  );
};

export default DateField;
